import { NEW_GRAMMAR_LANGUAGES } from '../constants/grammarLanguages';

export interface GrammarTopicDefinition {
  id: string;
  label: string;
}

export const GRAMMAR_TOPICS_CATALOG: Record<string, Record<string, GrammarTopicDefinition[]>> = {
  en: {
    a1: [
      { id: 'en_a1_01_verb_to_be', label: 'Verb to Be' },
      { id: 'en_a1_02_subject_pronouns', label: 'Subject Pronouns' },
      { id: 'en_a1_03_articles', label: 'Articles (a, an, the)' },
      { id: 'en_a1_04_plural_nouns', label: 'Plurals (s, es)' },
      { id: 'en_a1_05_demonstrative_pronouns', label: 'Demonstrative Pron.' },
      { id: 'en_a1_06_possessive_adjectives', label: 'Possessive Adjectives' },
      { id: 'en_a1_07_present_simple', label: 'Present Simple' },
      { id: 'en_a1_08_adverbs_of_frequency', label: 'Adverbs of Frequency' },
      { id: 'en_a1_09_prepositions_of_time', label: 'Prepositions (Time)' },
      { id: 'en_a1_10_prepositions_of_place', label: 'Prepositions (Place)' },
      { id: 'en_a1_11_can_cant', label: "Can / Can't" },
      { id: 'en_a1_12_object_pronouns', label: 'Object Pronouns' },
      { id: 'en_a1_13_there_is_there_are', label: 'There is / There are' },
      { id: 'en_a1_14_past_simple_verb_to_be', label: 'Past Simple (to be)' },
      { id: 'en_a1_15_imperatives', label: 'Imperatives' },
    ],
    a2: [
      { id: 'en_a2_01_present_continuous', label: 'Present Continuous' },
      { id: 'en_a2_02_past_simple', label: 'Past Simple' },
      { id: 'en_a2_03_comparatives_superlatives', label: 'Comparatives & Superlatives' },
      { id: 'en_a2_04_future_will_going_to', label: 'Future (Will / Going to)' },
      { id: 'en_a2_05_modals_obligation', label: 'Modals of Obligation' },
      { id: 'en_a2_06_present_perfect', label: 'Present Perfect' },
      { id: 'en_a2_07_countable_uncountable', label: 'Countable / Uncountable' },
      { id: 'en_a2_08_adverbs_of_manner', label: 'Adverbs of Manner' },
      { id: 'en_a2_09_prepositions_movement', label: 'Prepositions (Movement)' },
      { id: 'en_a2_10_conjunctions', label: 'Conjunctions' },
      { id: 'en_a2_11_passive_voice', label: 'Passive Voice' },
      { id: 'en_a2_12_relative_clauses', label: 'Relative Clauses' },
      { id: 'en_a2_13_first_conditional', label: 'First Conditional' },
      { id: 'en_a2_14_used_to', label: 'Used To' },
      { id: 'en_a2_15_reported_speech', label: 'Reported Speech' },
    ],
    b1: [
      { id: 'en_b1_01_past_continuous', label: 'Past Continuous' },
      { id: 'en_b1_02_present_perfect_continuous', label: 'Present Perfect Continuous' },
      { id: 'en_b1_03_past_perfect', label: 'Past Perfect' },
      { id: 'en_b1_04_second_conditional', label: 'Second Conditional' },
      { id: 'en_b1_05_modal_verbs', label: 'Modal Verbs' },
      { id: 'en_b1_06_gerund_infinitive', label: 'Gerund & Infinitive' },
      { id: 'en_b1_07_used_to', label: 'Used To' },
      { id: 'en_b1_08_tag_questions', label: 'Tag Questions' },
      { id: 'en_b1_09_relative_clauses', label: 'Relative Clauses' },
      { id: 'en_b1_10_modal_passive', label: 'Modal Passive' },
    ],
    b2: [
      { id: 'en_b2_01_third_conditional', label: 'Third Conditional' },
      { id: 'en_b2_02_mixed_conditionals', label: 'Mixed Conditionals' },
      { id: 'en_b2_03_passive_reporting_verbs', label: 'Passive Reporting Verbs' },
      { id: 'en_b2_04_causative_form', label: 'Causative Form' },
      { id: 'en_b2_05_future_continuous_perfect', label: 'Future Continuous & Perfect' },
      { id: 'en_b2_06_advanced_articles', label: 'Advanced Articles' },
      { id: 'en_b2_07_inversion_for_emphasis', label: 'Inversion for Emphasis' },
      { id: 'en_b2_08_linking_words', label: 'Linking Words' },
      { id: 'en_b2_09_wish_if_only', label: 'Wish & If Only' },
      { id: 'en_b2_10_advanced_quantifiers', label: 'Advanced Quantifiers' },
    ],
    c1: [
      { id: 'en_c1_01_subjunctive_mood', label: 'Subjunctive Mood' },
      { id: 'en_c1_02_participle_clauses', label: 'Participle Clauses' },
      { id: 'en_c1_03_cleft_sentences', label: 'Cleft Sentences' },
      { id: 'en_c1_04_advanced_conditional_inversion', label: 'Advanced Conditional Inversion' },
      { id: 'en_c1_05_nominalization', label: 'Nominalization' },
      { id: 'en_c1_06_ellipsis_substitution', label: 'Ellipsis & Substitution' },
      { id: 'en_c1_07_advanced_adverbials', label: 'Advanced Adverbials' },
      { id: 'en_c1_08_compound_adjectives', label: 'Compound Adjectives' },
      { id: 'en_c1_09_stance_adverbials', label: 'Stance Adverbials' },
      { id: 'en_c1_10_emphasis_focus', label: 'Emphasis & Focus' },
    ],
    c2: [
      { id: 'en_c2_01_distant_past_hypotheses', label: 'Distant Past Hypotheses' },
      { id: 'en_c2_02_sophisticated_connectors', label: 'Sophisticated Connectors' },
      { id: 'en_c2_03_double_comparatives', label: 'Double Comparatives' },
      { id: 'en_c2_04_complex_modal_passive', label: 'Complex Modal Passive' },
      { id: 'en_c2_05_idiomatic_phrasal_verbs', label: 'Idiomatic Phrasal Verbs' },
      { id: 'en_c2_06_stylistic_inversion', label: 'Stylistic Inversion' },
      { id: 'en_c2_07_advanced_reported_speech', label: 'Advanced Reported Speech' },
      { id: 'en_c2_08_rhetorical_figures', label: 'Rhetorical Figures' },
      { id: 'en_c2_09_textual_cohesion', label: 'Textual Cohesion' },
      { id: 'en_c2_10_register_control', label: 'Register Control' },
    ]
  },
  fr: {
    a1: [
      { id: 'fr_a1_01_verbe_etre', label: 'Verbe Être' },
      { id: 'fr_a1_02_verbe_avoir', label: 'Verbe Avoir' },
      { id: 'fr_a1_03_pronoms_sujets', label: 'Pronoms Sujets' },
      { id: 'fr_a1_04_articles_definis', label: 'Articles Définis' },
      { id: 'fr_a1_05_articles_indefinis', label: 'Articles Indéfinis' },
      { id: 'fr_a1_06_genre_et_nombre', label: 'Genre Et Nombre' },
      { id: 'fr_a1_07_present_des_verbes_er', label: 'Présent Des Verbes-er' },
      { id: 'fr_a1_08_verbes_ir_et_re', label: 'Verbes-ir Et-re' },
      { id: 'fr_a1_09_negation_ne_pas', label: 'Negation Ne Pas' },
      { id: 'fr_a1_10_questions_simples', label: 'Questions Simples' },
      { id: 'fr_a1_11_adjectifs_qualificatifs', label: 'Adjectifs Qualificatifs' },
      { id: 'fr_a1_12_adjectifs_possessifs', label: 'Adjectifs Possessifs' },
      { id: 'fr_a1_13_prepositions_de_lieu', label: 'Prepositions De Lieu' },
      { id: 'fr_a1_14_heure_et_date', label: 'Heure Et Date' },
      { id: 'fr_a1_15_il_y_a_et_c_est', label: 'Il Y A Et C Est' },
    ],
    a2: [
      { id: 'fr_a2_01_passe_compose', label: 'Passé Composé' },
      { id: 'fr_a2_02_imparfait', label: 'Imparfait' },
      { id: 'fr_a2_03_futur_proche', label: 'Futur Proche' },
      { id: 'fr_a2_04_futur_simple', label: 'Futur Simple' },
      { id: 'fr_a2_05_pronoms_objets_directs', label: 'Pronoms Objets Directs' },
      { id: 'fr_a2_06_pronoms_objets_indirects', label: 'Pronoms Objets Indirects' },
      { id: 'fr_a2_07_pronoms_y_et_en', label: 'Pronoms Y Et En' },
      { id: 'fr_a2_08_comparatif_et_superlatif', label: 'Comparatif Et Superlatif' },
      { id: 'fr_a2_09_adverbes', label: 'Adverbes' },
      { id: 'fr_a2_10_verbes_pronominaux', label: 'Verbes Pronominaux' },
      { id: 'fr_a2_11_expression_de_la_quantite', label: 'Expression De La Quantité' },
      { id: 'fr_a2_12_pronoms_relatifs', label: 'Pronoms Relatifs' },
      { id: 'fr_a2_13_obligation_et_interdiction', label: 'Obligation Et Interdiction' },
      { id: 'fr_a2_14_condition_si', label: 'Condition Si' },
      { id: 'fr_a2_15_expression_du_temps', label: 'Expression Du Temps' },
    ],
    b1: [
      { id: 'fr_b1_01_plus_que_parfait', label: 'Plus Que Parfait' },
      { id: 'fr_b1_02_conditionnel_present', label: 'Conditionnel Présent' },
      { id: 'fr_b1_03_discours_indirect', label: 'Discours Indirect' },
      { id: 'fr_b1_04_subjonctif_introduction', label: 'Subjonctif Introduction' },
      { id: 'fr_b1_05_voix_passive', label: 'Voix Passive' },
      { id: 'fr_b1_06_gerondif', label: 'Gérondif' },
      { id: 'fr_b1_07_connecteurs_logiques', label: 'Connecteurs Logiques' },
      { id: 'fr_b1_08_expression_des_sentiments', label: 'Expression Des Sentiments' },
      { id: 'fr_b1_09_hypothese', label: 'Hypothèse' },
      { id: 'fr_b1_10_pronoms_relatifs_avances', label: 'Pronoms Relatifs Avances' },
    ],
    b2: [
      { id: 'fr_b2_01_subjonctif_avance', label: 'Subjonctif Avancé' },
      { id: 'fr_b2_02_conditionnel_passe', label: 'Conditionnel Passé' },
      { id: 'fr_b2_03_discours_rapporte', label: 'Discours Rapporté' },
      { id: 'fr_b2_04_nominalisation', label: 'Nominalisation' },
      { id: 'fr_b2_05_cause', label: 'Cause' },
      { id: 'fr_b2_06_consequence', label: 'Consequence' },
      { id: 'fr_b2_07_but', label: 'But' },
      { id: 'fr_b2_08_opposition', label: 'Opposition' },
      { id: 'fr_b2_09_connecteurs_avances', label: 'Connecteurs Avances' },
      { id: 'fr_b2_10_registres_de_langue', label: 'Registres De Langue' },
    ],
    c1: [
      { id: 'fr_c1_01_subjonctif_complexe', label: 'Subjonctif Complexe' },
      { id: 'fr_c1_02_style_soutenu', label: 'Style Soutenu' },
      { id: 'fr_c1_03_constructions_impersonnelles', label: 'Constructions Impersonnelles' },
      { id: 'fr_c1_04_discours_formel', label: 'Discours Formel' },
      { id: 'fr_c1_05_modalite', label: 'Modalite' },
      { id: 'fr_c1_06_figures_de_style', label: 'Figures De Style' },
      { id: 'fr_c1_07_connecteurs_academiques', label: 'Connecteurs Academiques' },
      { id: 'fr_c1_08_abstraction', label: 'Abstraction' },
      { id: 'fr_c1_09_syntaxe_complexe', label: 'Syntaxe Complexe' },
      { id: 'fr_c1_10_langue_des_medias', label: 'Langue Des Médias' },
    ],
    c2: [
      { id: 'fr_c2_01_registre_litteraire', label: 'Registre Littéraire' },
      { id: 'fr_c2_02_nuances_semantiques', label: 'Nuances Sémantiques' },
      { id: 'fr_c2_03_rhetorique', label: 'Rhétorique' },
      { id: 'fr_c2_04_variations_stylistiques', label: 'Variations Stylistiques' },
      { id: 'fr_c2_05_expressions_idiomatiques', label: 'Expressions Idiomatiques' },
      { id: 'fr_c2_06_argumentation', label: 'Argumentation' },
      { id: 'fr_c2_07_implicite', label: 'Implicite' },
      { id: 'fr_c2_08_langue_academique', label: 'Langue Academique' },
      { id: 'fr_c2_09_maitrise_du_discours', label: 'Maîtrise Du Discours' },
      { id: 'fr_c2_10_registre_et_nuance', label: 'Registre Et Nuance' },
    ]
  },
  it: {
    a1: [
      { id: 'it_a1_01_verbo_essere', label: "Che cos'è il verbo 'Essere'?" },
      { id: 'it_a1_02_articoli_determinativi_e_indeterminativi', label: 'Articoli Determinativi e Indeterminativi' },
      { id: 'it_a1_03_sostantivi_regolari', label: 'Sostantivi Regolari' },
      { id: 'it_a1_04_aggettivi_qualificativi', label: 'Aggettivi Qualificativi' },
      { id: 'it_a1_05_i_verbi_regolari_in_are', label: 'Verbi Regolari in -are' },
      { id: 'it_a1_06_i_verbi_regolari_in_ere', label: 'Verbi Regolari in -ere' },
      { id: 'it_a1_07_i_verbi_regolari_in_ire', label: 'Verbi Regolari in -ire' },
      { id: 'it_a1_08_i_verbi_ausiliari_essere_avere', label: 'Verbi Ausiliari (Essere / Avere)' },
      { id: 'it_a1_09_articoli_determinativi_indeterminativi', label: 'Articoli (Revisione e Uso)' },
      { id: 'it_a1_10_i_pronome_personale_soggetto', label: 'Pronomi Personali Soggetto' },
      { id: 'it_a1_11_le_preposizioni_semplici', label: 'Preposizioni Semplici' },
      { id: 'it_a1_12_le_preposizioni_articolate', label: 'Preposizioni Articolate' },
      { id: 'it_a1_13_i_verbi_riflessivi', label: 'Verbi Riflessivi' },
      { id: 'it_a1_14_il_passato_prossimo', label: 'Passato Prossimo' },
      { id: 'it_a1_15_i_verbi_modali_potere_volere_dovere', label: 'Verbi Modali (Potere, Volere, Dovere)' },
    ],
    a2: [
      { id: 'it_a2_01_passe_compose', label: "L'imperfetto Indicativo" },
      { id: 'it_a2_02_gli_aggettivi_possessivi', label: 'Gli Aggettivi e Pronomi Possessivi' },
      { id: 'it_a2_03_futur_proche', label: 'Il Futuro Semplice' },
      { id: 'it_a2_04_futur_simple', label: 'Il Futuro Anteriore' },
      { id: 'it_a2_05_i_pronomi_diretti', label: 'I Pronomi Diretti' },
      { id: 'it_a2_06_i_pronomi_indiretti', label: 'I Pronomi Indiretti' },
      { id: 'it_a2_07_passato_prossimo_vs_imperfetto', label: 'Passato Prossimo vs Imperfetto' },
      { id: 'it_a2_08_i_verbi_riflessivi', label: 'I Pronomi Ci e Ne' },
      { id: 'it_a2_09_adverbes', label: 'Gli Avverbi di Modo e Tempo' },
      { id: 'it_a2_10_i_pronomi_combinati', label: 'I Pronomi Combinati' },
      { id: 'it_a2_11_i_pronomi_relativi', label: 'I Pronomi Relativi (Che, Cui)' },
      { id: 'it_a2_12_pronoms_relatifs', label: 'I Verbi Pronominali' },
      { id: 'it_a2_13_obligation_et_interdiction', label: "Espressione dell'Obbligo e Divieto" },
      { id: 'it_a2_14_condition_si', label: 'La Condizione con Se' },
      { id: 'it_a2_15_expression_du_temps', label: "L'Espressione del Tempo" },
    ],
    b1: [
      { id: 'it_b1_01_plus_que_parfait', label: 'Il Passato Remoto' },
      { id: 'it_b1_02_il_trapassato_prossimo', label: 'Il Trapassato Prossimo' },
      { id: 'it_b1_03_discours_indirect', label: 'Il Condizionale Presente e Passato' },
      { id: 'it_b1_04_subjonctif_introduction', label: 'Introduzione al Congiuntivo' },
      { id: 'it_b1_05_il_congiuntivo_presente', label: 'Il Congiuntivo Presente' },
      { id: 'it_b1_06_il_congiuntivo_passato', label: 'Il Congiuntivo Passato' },
      { id: 'it_b1_07_il_congiuntivo_imperfetto', label: 'Il Congiuntivo Imperfetto' },
      { id: 'it_b1_08_expression_des_sentiments', label: 'La Forma Passiva e Gerundio' },
      { id: 'it_b1_09_il_periodo_ipotetico', label: 'Il Periodo Ipotetico' },
      { id: 'it_b1_10_il_discorso_indiretto', label: 'Il Discorso Indiretto' },
    ],
    b2: [
      { id: 'it_b2_01_subjonctif_avance', label: 'Il Congiuntivo Trapassato e Avanzato' },
      { id: 'it_b2_02_il_si_impersonale_e_passivante', label: 'Il Si Impersonale e Passivante' },
      { id: 'it_b2_03_discours_rapporte', label: 'Il Discorso Riportato Avanzato' },
      { id: 'it_b2_04_nominalisation', label: 'La Nominalizzazione' },
      { id: 'it_b2_05_cause', label: 'Esprimere la Causa' },
      { id: 'it_b2_06_consequence', label: 'Esprimere la Conseguenza' },
      { id: 'it_b2_07_but', label: 'Esprimere lo Scopo' },
      { id: 'it_b2_08_opposition', label: "Esprimere l'Opposizione e Concessione" },
      { id: 'it_b2_09_connecteurs_avances', label: 'I Connettori Testuali Avanzati' },
      { id: 'it_b2_10_registres_de_langue', label: 'I Registri Linguistici' },
    ],
    c1: [
      { id: 'it_c1_01_subjonctif_complexe', label: 'Il Congiuntivo nei Periodi Complessi' },
      { id: 'it_c1_02_style_soutenu', label: 'Lo Stile Sostenuto e Formale' },
      { id: 'it_c1_03_constructions_impersonnelles', label: 'Le Costruzioni Impersonali Avanzate' },
      { id: 'it_c1_04_discours_formel', label: 'Il Discorso Formale ed Epistolare' },
      { id: 'it_c1_05_modalite', label: 'La Modalità ed Espressione del Dubbio' },
      { id: 'it_c1_06_figures_de_style', label: 'Le Figure Retoriche e di Stile' },
      { id: 'it_c1_07_connecteurs_academiques', label: 'I Connettori Accademici' },
      { id: 'it_c1_08_abstraction', label: "L'Astrazione e Linguaggio Specialistico" },
      { id: 'it_c1_09_syntaxe_complexe', label: 'La Sintassi Complessa' },
      { id: 'it_c1_10_langue_des_medias', label: 'La Lingua dei Media e Giornalismo' },
    ],
    c2: [
      { id: 'it_c2_01_registre_litteraire', label: 'Il Registro Letterario e Arcaico' },
      { id: 'it_c2_02_nuances_semantiques', label: 'Le Sfumature Semantiche e Sinonimia' },
      { id: 'it_c2_03_rhetorique', label: 'La Retorica e Persuasione Avanzata' },
      { id: 'it_c2_04_variations_stylistiques', label: "Le Variazioni Stilistiche d'Autore" },
      { id: 'it_c2_05_expressions_idiomatiques', label: 'Le Espressioni Idiomatiche Complesse' },
      { id: 'it_c2_06_argumentation', label: "L'Argomentazione Filosofica e Giuridica" },
      { id: 'it_c2_07_implicite', label: "L'Implicito e l'Ironia nel Discorso" },
      { id: 'it_c2_08_langue_academique', label: 'La Lingua Accademica Superiore' },
      { id: 'it_c2_09_maitrise_du_discours', label: 'La Padronanza Assoluta del Discorso' },
      { id: 'it_c2_10_registre_et_nuance', label: 'Registro, Nuance e Sensibilità Linguistica' },
    ]
  }
};

// Idiomas novos (es, pt, de, ru, hu): mesmos módulos da página de gramática
for (const [code, meta] of Object.entries(NEW_GRAMMAR_LANGUAGES)) {
  GRAMMAR_TOPICS_CATALOG[code] = Object.fromEntries(
    Object.entries(meta.levels).map(([lv, mods]) => [lv, mods.map(m => ({ id: m.id, label: m.label }))])
  );
}

export function getGrammarTopicsForLangAndLevel(lang: string, level: string): GrammarTopicDefinition[] {
  const cleanLang = (lang || 'en').toLowerCase().trim();
  const cleanLevel = (level || 'a1').toLowerCase().trim();
  
  const langTopics = GRAMMAR_TOPICS_CATALOG[cleanLang];
  if (langTopics && langTopics[cleanLevel] && langTopics[cleanLevel].length > 0) {
    return langTopics[cleanLevel];
  }

  // Fallback to English level or English a1
  if (GRAMMAR_TOPICS_CATALOG['en']?.[cleanLevel]) {
    return GRAMMAR_TOPICS_CATALOG['en'][cleanLevel];
  }
  return GRAMMAR_TOPICS_CATALOG['en']['a1'];
}
